export const environment = {
  production: false,
  apiUrl: 'https://devbaiterek.idet.kz/objects-back/',
  apiWidget: 'https://devbaiterek.idet.kz/widgets-back/',
};
